import {AlertInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {Skeleton} from '@mui/material';
import {StyledTitle} from './styles';
import {usePatientData} from '../../../PatientData/hooks/usePatientData';

const {forecast, unpredictable} =
	translations['pt-br'].privateFlow.myHospitalization.home.bullishForecastAlert;

export const BullishForecastAlert = () => {
	const {data, isError, isLoading} = usePatientData();
	const forecastDate = data?.dischargePlanTherapeuticDateTime;

	if (isLoading || isError) {
		return <Skeleton variant="rectangular" width={'100%'} height={52} />;
	}

	if (forecastDate && forecastDate !== null) {
		return (
			<AlertInfo.Root severity="info">
				<AlertInfo.Title title={forecast.title.replace('::date', forecastDate)} />
				<AlertInfo.Description>{forecast.subtitle}</AlertInfo.Description>
			</AlertInfo.Root>
		);
	}

	return (
		<AlertInfo.Root severity="info">
			<AlertInfo.Description>
				<StyledTitle>{unpredictable}</StyledTitle>
			</AlertInfo.Description>
		</AlertInfo.Root>
	);
};
